(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articles-slider"] && !Shopify.designMode) return;
  try {
    
  const articlesSectionSlider = () => {
    new Swiper(".articles__slider", {
      freeMode: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".articles__slider .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    articlesSectionSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ba-slider"]) return;
  try {
    
  const baSlider = () => {
    new Swiper('.ba_slider__swiper', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      centerInsufficientSlides: true,
      scrollbar: {
        el: ".ba_slider__swiper .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
    })
  }
  document.addEventListener('DOMContentLoaded', baSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-slider"] && !Shopify.designMode) return;
  try {
    
  const cardsSlider = () => {
    new Swiper('.cards_slider_swiper', {
      slidesPerView: "auto",
      spaceBetween: 20,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.cards_slider_swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    cardsSlider();      
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["images-slider-v2"] && !Shopify.designMode) return;
  try {
    
  const bAfterSwiper = () => {
    new Swiper('.swiper.bAfterSwiper', {
      breakpoints: {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 15,
        loop: true
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 15,
        loop: false
      },
    },
      spaceBetween: 16,
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true
      },
    })
  }
  document.addEventListener('DOMContentLoaded', bAfterSwiper)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  const multicolumnSlider = () => {
    new Swiper('.multicolumns_swiper', {
      slidesPerView: "auto",
      spaceBetween: 32,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.multicolumns_swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    multicolumnSlider();      
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pads-tech"]) return;
  try {
    
  const bundlerSlider = () => {
    new Swiper(".blundleSlider", {
      slidesPerView: 'auto',
      freeMode: true,
      keyboard: {
          enabled: true,
          onlyInViewport: true
      },
      mousewheel: {
          forceToAxis: true
      },
      // scrollbar: {
      //     el: '.blundleSlider .swiper-scrollbar',
      //     freeMode: true,
      //     draggable: true,
      //     hide: false
      // },
      watchOverflow: true,
      spaceBetween: 16,
      centerInsufficientSlides: true
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    bundlerSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-bundle"]) return;
  try {
    
  const bundleSwiper = () => {
    new Swiper('.shop-bundle__content_mobile__swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.shop-bundle__content_mobile__swiper__nav .swiper-button-next',
        prevEl: '.shop-bundle__content_mobile__swiper__nav .swiper-button-prev',
      }
    })
  }
  document.addEventListener('DOMContentLoaded', () => {
    bundleSwiper()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-table"] && !Shopify.designMode) return;
  try {
    
  const tableSlider = () => {
    new Swiper('.slider-table__swiper', {
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      centerInsufficientSlides: true,
      scrollbar: {
        el: '.slider-table__swiper .swiper-scrollbar',
        freeMode: true,
        draggable: true,
        hide: false
      },
    })
  }
  
  if (window.innerWidth < 769) {
    document.addEventListener("DOMContentLoaded", () => {
      tableSlider();      
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-banner"] && !Shopify.designMode) return;
  try {
    
  const setSubscription = () => {
    const link = "/products/pro-sculpt-starter-kit-subscription"
    const container = document.querySelector(".product_sub__content")
    const elementToGo = container?.querySelector('.product_sub__form__variants')
    const label = container?.querySelector("label[for='subscription']")
    const topSpace = 60
    
    if (label) {
      label.click()

      if (elementToGo) {
        const elementToGoPosition = elementToGo.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementToGoPosition - topSpace,
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = link
    }
  }

  window.setSubscription = setSubscription;

  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".sub-banner__items", {
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".sub-banner__items .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 6,
      slidesPerView: 2.2,
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["target-fat-slider-v2"]) return;
  try {
    
  const targetFatSliderV2 = () => {
    new Swiper('.target-fat-slider-v2__swiper', {
      slidesPerView: 2.2,
      spaceBetween: 15,
      centerInsufficientSlides: true, 
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        }
      }
    })
  }
  document.addEventListener('DOMContentLoaded', targetFatSliderV2);

  } catch(e) { console.error(e); }
})();
})();
